/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { CanReviewResponse } from '../../models/can-review-response';

export interface TravelControllerUserCanReviewTourLeader$Params {
  tour_leader_id: number;
}

export function travelControllerUserCanReviewTourLeader(http: HttpClient, rootUrl: string, params: TravelControllerUserCanReviewTourLeader$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CanReviewResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, travelControllerUserCanReviewTourLeader.PATH, 'get');
  if (params) {
    rb.path('tour_leader_id', params.tour_leader_id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: CanReviewResponse;
      }>;
    })
  );
}

travelControllerUserCanReviewTourLeader.PATH = '/travel/reviews/tour-leader/{tour_leader_id}/can_review';
